/**
 * @fileoverview Application-level error codes.
 * @description Stable string codes for domain errors so UI code and future error tracking can
 * match on a code instead of a human-readable message that may change wording.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

export const ERROR_CODES = {
  AUTH_INVALID_CREDENTIALS: 'AUTH_INVALID_CREDENTIALS',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  RATE_LIMITED: 'RATE_LIMITED',
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
  MFA_INVALID_CODE: 'MFA_INVALID_CODE',
  MFA_CHALLENGE_EXPIRED: 'MFA_CHALLENGE_EXPIRED',
  MFA_MAX_ATTEMPTS_EXCEEDED: 'MFA_MAX_ATTEMPTS_EXCEEDED',
  MFA_MAX_RESENDS_EXCEEDED: 'MFA_MAX_RESENDS_EXCEEDED',
  MFA_CHALLENGE_INVALID: 'MFA_CHALLENGE_INVALID',
  AUTH_FLOW_EXPIRED: 'AUTH_FLOW_EXPIRED',
  CURRENT_PASSWORD_INCORRECT: 'CURRENT_PASSWORD_INCORRECT',
  PASSWORD_POLICY_REJECTED: 'PASSWORD_POLICY_REJECTED',
  PASSWORD_CHANGE_REQUIRED: 'PASSWORD_CHANGE_REQUIRED',
  PASSWORD_RESET_TOKEN_INVALID: 'PASSWORD_RESET_TOKEN_INVALID',
  REQUEST_ORIGIN_REJECTED: 'REQUEST_ORIGIN_REJECTED',
  INVITATION_INVALID: 'INVITATION_INVALID',
  FORBIDDEN: 'FORBIDDEN',
  STEP_UP_MFA_REQUIRED: 'STEP_UP_MFA_REQUIRED',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  PRECONDITION_FAILED: 'PRECONDITION_FAILED',
  /** The record changed since it was read (a stale If-Match); refetch it and retry. */
  VERSION_CONFLICT: 'VERSION_CONFLICT',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  PAYLOAD_TOO_LARGE: 'PAYLOAD_TOO_LARGE',
  NETWORK_ERROR: 'NETWORK_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
} as const

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES]
